module.exports = __webpack_public_path__ + "img/logo.ce413ad4.png";